var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0109 0C18.8955 0.0329167 21.5014 0.74186 23.8287 2.12683C26.1283 3.48415 28.0411 5.40872 29.3844 7.71649C30.7609 10.0578 31.4656 12.6795 31.4984 15.5817C31.4167 19.5525 30.1642 22.944 27.7411 25.7561C25.318 28.5682 22.2146 30.308 19.0019 30.9749V19.8419H22.0392L22.7261 15.4669H18.1269V12.6014C18.1014 12.0074 18.2893 11.4238 18.6565 10.9562C19.0244 10.4874 19.6721 10.2409 20.5996 10.2169H23.3769V6.38454C23.3371 6.37172 22.959 6.32102 22.2425 6.23244C21.4301 6.13738 20.613 6.08661 19.795 6.08034C17.9437 6.08888 16.4795 6.61112 15.4025 7.64705C14.3254 8.6827 13.7753 10.181 13.7519 12.1421V15.4669H10.2519V19.8419H13.7519V30.9749C9.80727 30.308 6.70382 28.5682 4.2807 25.7561C1.85757 22.944 0.6052 19.5525 0.523438 15.5817C0.55615 12.6794 1.26081 10.0577 2.63741 7.71649C3.98071 5.40872 5.89359 3.48416 8.19314 2.12683C10.5204 0.742127 13.1263 0.0331833 16.0109 0Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d51c63407ffd5f103d9e816333bdab14.svg";
export { ForwardRef as ReactComponent };